import { Box } from '@mui/material';

import { Operation } from './interfaces';
import { DetailsType } from '../../../../../../common/details-list/interface';
import Divider from '../../../../../../common/divider/divider';
import Events from '../events';
import OperationMetadata from '../operation-metadata';

interface Props {
  operation: Operation;
  detailsType: DetailsType;
}

const SuccessOperation = ({ operation, detailsType }: Props) => {
  const { events } = operation;
  return (
    <Box flexDirection="column" display="flex" justifyContent="space-between">
      <OperationMetadata operation={operation} detailsType={detailsType} />
      <Divider />
      <Box sx={{ height: '100%' }}>
        <Events events={events} />
      </Box>
    </Box>
  );
};

export default SuccessOperation;
